module.exports = __webpack_public_path__ + "media/images/online_talks/HRANK-fa59f894d69b33a7f362defdfdb80511.png";